import type { ReactNode } from 'react';

type Props = {
  open: boolean;
  tab: string;
  onToggle: () => void;
  onTab?: (tab: string) => void;
  children?: ReactNode;
};

export default function ComposeDrawer({ open, onToggle, children }: Props) {
  return (
    <aside
      data-testid="compose-drawer"
      className={`relative shrink-0 border-r border-border bg-bg overflow-hidden ${open ? 'w-[360px]' : 'w-0'}`}
    >
      <button
        type="button"
        data-testid="drawer-chevron"
        onClick={onToggle}
        className="absolute top-3 right-2 z-10 w-7 h-7 rounded-md flex items-center justify-center text-texts hover:text-textp hover:bg-surface2"
        title={open ? 'Collapse drawer' : 'Open drawer'}
      >
        <i className={`ri-arrow-${open ? 'left' : 'right'}-s-line text-lg`} />
      </button>
      {open ? children : null}
    </aside>
  );
}
